<template>
	<sky-suffix v-bind="$attrs" @search-click="search">
		<el-radio-group
			v-model="radio"
			:value="radio"
			@change="handleChange"
			@input="input"
			v-bind="$attrs"
			class="radio-group"
		>
			<el-radio
				v-for="item in options"
				v-bind="getCustAttrs(item)"
				:label="item[props.value]"
				:key="item[props.value]"
				:border="!border"
				>{{ item[props.label] }}</el-radio
			>
		</el-radio-group>

		<slot name="toolTips" slot="toolTips"></slot>
	</sky-suffix>
</template>
<script>
import SkySuffix from '../formComponents/SkySuffix.vue';
export default {
	name: 'sky-radio',
	componentName: 'sky-radio',
	components: {
		SkySuffix,
	},
	props: {
		name: {},
		value: {},
		options: {},
		border: Boolean,
		props: {
			default() {
				return {
					label: 'label',
					value: 'value',
				};
			},
		},
	},
	created() {},
	watch: {
		value: {
			handler(val) {
				this.radio = val;
			},
			immediate: true,
		},
	},
	data() {
		return {
			radio: this.value,
		};
	},
	methods: {
		search(e) {
			this.$emit('search-click', e);
		},
		input(e) {
			this.$emit('input', e);
		},
		handleChange(e) {
			this.$emit('change', e);
		},
		getCustAttrs(item) {
			if (item && item.custAttrs) return item.custAttrs(item);
			return item;
		},
	},
};
</script>
<style lang="scss" scoped>
.el-radio {
	margin: 5px 10px 5px 0;
}
</style>
